// Isolates `import.meta.url` (a CRA build-time construct that Jest's babel
// transform cannot parse) into a single, mockable factory. App imports this
// instead of constructing the Worker inline, so App.js stays Jest-importable.
export function createPermsWorker() {
  return new Worker(new URL('./permsWorker.js', import.meta.url));
}
